import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const Content = ({ children, ...props }) => (
  <section className="content-block">
    <div className="block-inner" {...props}>
      {children}
    </div>
  </section>
);

Content.propTypes = {
  children: PropTypes.node,
};

export default Content;
